/* ══ HOME ASSISTANT CONSTANTS ═════════════════════════════ */

/* ── Entity domain → display info mapping ── */
export const HA_DOMAINS = {
  light:                { icon: "light",    label: "Light",           labelAr: "إضاءة",          controllable: true  },
  switch:               { icon: "switch",   label: "Switch",          labelAr: "مفتاح",          controllable: true  },
  climate:              { icon: "climate",  label: "Climate",         labelAr: "مكيف",           controllable: true  },
  lock:                 { icon: "lock",     label: "Lock",            labelAr: "قفل",            controllable: true  },
  cover:                { icon: "cover",    label: "Cover",           labelAr: "غطاء",           controllable: true  },
  fan:                  { icon: "fan",      label: "Fan",             labelAr: "مروحة",          controllable: true  },
  media_player:         { icon: "media",    label: "Media Player",    labelAr: "مشغل وسائط",     controllable: true  },
  scene:                { icon: "scene",    label: "Scene",           labelAr: "مشهد",           controllable: true  },
  automation:           { icon: "auto",     label: "Automation",      labelAr: "أتمتة",          controllable: true  },
  sensor:               { icon: "sensor",   label: "Sensor",          labelAr: "مستشعر",         controllable: false },
  binary_sensor:        { icon: "sensor",   label: "Binary Sensor",   labelAr: "مستشعر ثنائي",   controllable: false },
  weather:              { icon: "weather",  label: "Weather",         labelAr: "الطقس",          controllable: false },
  camera:               { icon: "camera",   label: "Camera",          labelAr: "كاميرا",         controllable: false },
  alarm_control_panel:  { icon: "alarm",    label: "Alarm",           labelAr: "إنذار",          controllable: true  },
  vacuum:               { icon: "vacuum",   label: "Vacuum",          labelAr: "مكنسة",          controllable: true  },
  water_heater:         { icon: "climate",  label: "Water Heater",    labelAr: "سخان مياه",      controllable: true  },
  humidifier:           { icon: "climate",  label: "Humidifier",      labelAr: "مرطب",           controllable: true  },
};

/* Domains we display on the dashboard (filter out internal / noisy ones) */
export const DASHBOARD_DOMAINS = new Set([
  "light", "switch", "climate", "lock", "cover", "fan",
  "media_player", "sensor", "binary_sensor", "camera",
  "alarm_control_panel", "vacuum", "water_heater", "humidifier",
  "automation",
]);

/* Domains that appear in the security panel */
export const SECURITY_DOMAINS = new Set(["lock", "alarm_control_panel", "binary_sensor"]);

/* Binary sensor device classes relevant to security */
export const SECURITY_SENSOR_CLASSES = new Set([
  "door", "window", "motion", "opening", "garage_door", "lock", "tamper",
]);

/* ── Entity state helpers ── */
export function isEntityOn(entity) {
  if (!entity) return false;
  const s = entity.state;
  return s === "on" || s === "open" || s === "unlocked" || s === "playing" ||
         s === "home" || s === "active" || s === "heat" || s === "cool" ||
         s === "heating" || s === "cooling";
}

export function entityDomain(entityId) {
  if (!entityId) return "";
  return entityId.split(".")[0];
}

/* Group entities by HA area_id, falling back to "unassigned" */
export function groupByArea(entities, areas) {
  const areaMap = {};
  for (const a of areas) areaMap[a.area_id] = a;

  const groups = {};
  for (const e of entities) {
    const areaId = e.area_id || "unassigned";
    if (!groups[areaId]) {
      const area = areaMap[areaId];
      groups[areaId] = {
        areaId,
        name: area?.name || "Other",
        entities: [],
      };
    }
    groups[areaId].entities.push(e);
  }
  return groups;
}

/* ── Climate HVAC modes ── */
export const HVAC_MODES = ["off", "heat", "cool", "heat_cool", "auto", "dry", "fan_only"];

/* ── Cover commands ── */
export const COVER_COMMANDS = ["open_cover", "close_cover", "stop_cover"];

/* ── WebSocket message types ── */
export const WS_MSG = {
  AUTH_REQUIRED: "auth_required",
  AUTH_OK: "auth_ok",
  AUTH_INVALID: "auth_invalid",
  RESULT: "result",
  EVENT: "event",
  PONG: "pong",
};
